import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLinktree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="linktree" maskId="round-filled-radius-0-stroke-1.5-IconLinktree"><path d="M13.4657 6.87709L16.846 3.44655L18.8084 5.43055L15.2626 8.76777H20.25V11.5217H15.239L18.8084 14.9448L16.846 16.8896L12.0004 12.0825L7.15483 16.8896L5.19245 14.9523L8.76187 11.5292H3.75V8.76777H8.73739L5.19161 5.43055L7.15398 3.44655L10.5343 6.87709V2H13.4657V6.87709ZM10.5343 15.4655H13.4657V22H10.5343V15.4655Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLinktree;
